import { Children, Fragment, ReactNode } from 'react';

export const HeaderSection = ({ children }: { children: Array<ReactNode> | ReactNode }) => {
  const childArray = Children.toArray(children);
  const visibleChildren = childArray.filter(Boolean);
  return (
    <div className="flex items-center">
      {visibleChildren.map((child, index) => (
        <Fragment key={index}>
          {child}
          {index < visibleChildren.length - 1 && <HeaderSectionDivider />}
        </Fragment>
      ))}
    </div>
  );
};

export const HeaderSectionDivider = () => <div className="mx-2 w-px self-stretch bg-gray-200" />;
